<template>
  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.195262 10.7197C-0.0650874 11.0126 -0.0650874 11.4874 0.195262 11.7803C0.455612 12.0732 0.877722 12.0732 1.13807 11.7803L5.80474 6.53033C6.06509 6.23744 6.06509 5.76256 5.80474 5.46967L1.13807 0.21967C0.877722 -0.0732233 0.455612 -0.0732233 0.195262 0.21967C-0.0650874 0.512563 -0.0650874 0.987437 0.195262 1.28033L4.39052 6L0.195262 10.7197Z" fill="#262626"/>
  </svg>
</template>

<script>
export default {
  name: 'arrowRight'
}
</script>

<style scoped>

</style>
